module.exports = __webpack_public_path__ + "img/option-02.e6dccc22.svg";